import type { GeoJSONSourceSpecification } from "mapbox-gl";

export const emptyFeatureCollection: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
  type: "FeatureCollection",
  features: [],
};

export function emptyGeoJsonSource(): GeoJSONSourceSpecification {
  return {
    type: "geojson",
    data: emptyFeatureCollection,
  };
}
